import FontAwesome from "../../../../utilities/FontAwesome";
import * as React from "react";
import ClickableLink from "../../../../utilities/ClickableLink";

export interface IBlockInfo {
    title: string,
    addText: string,
    label?: string,
    icon?: JSX.Element,
    helpDocUrl?: string,
    videos: {
        title: string,
        url: string,
    }[],
    actionButtonClass?: string,
    actionButtonText?: string,
    children?: JSX.Element,
}

const socialBlockInfo = {
    label: "Social",
    icon: <FontAwesome fixedWidth prefix={'fas'} name={'fa-share-alt'} />,
    title: "Social Media",
    addText: "a Social Media Block",
    helpDocUrl: 'https://docs.google.com/viewer?pid=explorer&embedded=true&srcid=13k_q4tUSiQp5zNrCtKhV5E4FlRV7HFWmhV-gXZNsqKI',
    videos: [{
        title: "Play Video",
        url: 'https://www.youtube.com/embed/2bPPFXI0_PY',
    }],
};

export const blockEditInfo: {[type: string]: JSX.Element} = {
    sharedfiles: <p style={{marginBottom: "3em", padding: "0 1rem"}}>A file block can display a single file or all of the files and folders
        inside of a public folder on Google Drive or Microsoft OneDrive.</p>,
}

export const blockTypeInfo: {[type: string]: IBlockInfo} = {
    message: {
        title: "Message",
        addText: "a Message Block",
        icon: <FontAwesome fixedWidth prefix={'fas'} flip={'horizontal'} name={"fa-comment"} />,
        helpDocUrl: 'https://docs.google.com/viewer?pid=explorer&embedded=true&srcid=1g4yPP2dNIf5DGdflJxFtpusgziJ3MAkP8cgY4wpScbE',
        videos: [{
            title: "Play Video",
            url: 'https://www.youtube.com/embed/NfzdJXNw5EM',
        }],
    },
    eventlist: {
        label: "Events",
        icon: <FontAwesome fixedWidth name={"fa-calendar"} prefix={"far"}/>,
        title: "Event List",
        addText: "an Events Block",
        helpDocUrl: 'https://docs.google.com/viewer?pid=explorer&embedded=true&srcid=1gTyZ3JCsx_-ZU86uvsFafP7TWLhVgj2B8pOMQvJIGew',
        videos: [{
            title: "Play Video",
            url: 'https://www.youtube.com/embed/1j-yYDTRfZ0',
        }],
        children: <>
            <div style={{paddingLeft: "20px", marginTop: "2rem"}}>
                <h4>Supported Calendars</h4>
                <small style={{display: "block"}}>{`Note that shared files must be ADA compliant.`}</small>
            </div>
            <div>
                <ClickableLink href="https://support.google.com/calendar/answer/37648?hl=en" target="_blank"
                               rel="noopener noreferrer">
                    <FontAwesome fixedWidth name={"fa-google-plus-g"} prefix={"fab"} size={"2x"}/>
                    <h4>Google Calendar</h4>
                </ClickableLink>
            </div>
            <div>
                <ClickableLink href="http://support.apple.com/kb/PH2690" target="_blank"
                               rel="noopener noreferrer">
                    <FontAwesome fixedWidth name={"fa-apple"} prefix={"fab"} size={"2x"}/>
                    <h4>iCloud Calendar</h4>
                </ClickableLink>
            </div>
            <div>
                <ClickableLink
                    href="https://support.office.com/en-ie/article/Sharing-your-calendar-in-Outlook-Web-App-7ecef8ae-139c-40d9-bae2-a23977ee58d5#__toc375064921">
                    <FontAwesome fixedWidth name={"fa-windows"} prefix={"fab"} size={"2x"}/>
                    <h4>Outlook Calendar</h4>
                </ClickableLink>
            </div>
        </>
    },
    sharedfiles: {
        title: "Files",
        addText: "a Files Block",
        icon: <FontAwesome fixedWidth name={'fa-file-image'} prefix={'fas'} />,
        helpDocUrl:
            'https://docs.google.com/viewer?pid=explorer&embedded=true&srcid=1le1cA2nQ3rSZ-eAf4iWtu-WrOGYzMQYI1d3hop_S5l8',
        videos:
            [{
                title: "Play Video",
                url: 'https://www.youtube.com/embed/4zPMRwYU8pM',
            }],
        children: <>
            <div style={{paddingLeft: "20px", marginTop: "2rem"}}>
                <h4>Supported File Types</h4>
                <small style={{display: "block"}}>{`Note that shared files must be ADA compliant.`}</small>
            </div>
            <div>
                <ClickableLink href="https://support.google.com/drive/answer/2494886?hl=en">
                    <FontAwesome name={"fa-google-plus-g"} fixedWidth size={"2x"} prefix={"fab"}/>
                    <h4>Google Drive</h4>
                </ClickableLink>
            </div>
            <div>
                <ClickableLink href="http://windows.microsoft.com/en-us/onedrive/share-file-folder">
                    <FontAwesome name={"fa-windows"} fixedWidth prefix={"fab"} size={"2x"}/>
                    <h4>Microsoft Office</h4>
                </ClickableLink>
            </div>
        </>,
    },
    quicklink: {
        title: "Links",
        addText: "a Links Block",
        icon: <FontAwesome fixedWidth prefix={'fas'} name={'fa-link'}/>,
        helpDocUrl: 'https://docs.google.com/viewer?pid=explorer&embedded=true&srcid=1ru9l0QsvM4gtc_Qe4vD4W0u5aX_lXKtC5cR_608GMHA',
        videos: [],
    },
    notification: {
        title: "Alert",
        addText: "an Alert",
        icon: <FontAwesome fixedWidth name={"fa-exclamation-triangle"} prefix={"fas"} aria-label="Add alert"/>,
        actionButtonClass: 'sb-admin-menu-manage-notification',
        actionButtonText: "Manage Alerts",
        helpDocUrl: 'https://docs.google.com/viewer?pid=explorer&embedded=true&srcid=1SfoiuSmetyLDArWMKUOJEcZV2VCfnJgYMV-WgwyIn0I',
        videos: [],
    },
    html: {
        title: "HTML",
        addText: "an HTML Block",
        icon: <FontAwesome fixedWidth prefix={'fas'} name={'fa-code'}/>,
        helpDocUrl: 'https://docs.google.com/viewer?pid=explorer&embedded=true&srcid=17F-7MhfgQcEdX-9DHRoRj0y-3GA94Cu790F7hD6TKKQ',
        videos: [{
            title: "Play Video",
            url: 'https://www.youtube.com/embed/L_ZraHcw1SU',
        }],
    },
    staff: {
        title: "Staff",
        addText: "a Staff Block",
        icon: <FontAwesome fixedWidth name={'fa-users'} prefix={'fas'}/>,
        helpDocUrl: 'https://docs.google.com/viewer?pid=explorer&embedded=true&srcid=1TV24X22P01ngdXWS10515JnJ2La2Pxgl6TWLl6SB_-U',
        videos: [{
            title: "Play Video",
            url: 'https://www.youtube.com/embed/HHtFC-BNp84',
        }],
    },
    video: {
        title: "Video",
        addText: "a Video Block",
        icon: <FontAwesome fixedWidth name={'fa-video'} prefix={'fas'}/>,
        helpDocUrl: 'https://docs.google.com/viewer?pid=explorer&embedded=true&srcid=1_Dv5wX28DnDtQ21_zicTWCydYHqwWSAFvyoP_oVW7F8',
        videos: [],
    },
    youtube: socialBlockInfo,
    social: socialBlockInfo,
    facebook: socialBlockInfo,
    twitter: socialBlockInfo,
    instagram: socialBlockInfo,
    pinterest: socialBlockInfo,
    news: {
        title: "News",
        addText: "a News Block",
        icon: <FontAwesome fixedWidth name={'fa-bullhorn'} prefix={'fas'}/>,
        helpDocUrl: 'https://docs.google.com/viewer?pid=explorer&embedded=true&srcid=1P0kTqeZ5subt-fBitPS7ZSkho42Wa8YEQlcgABxOwz8',
        videos: [{
            title: "Play Video",
            url: 'https://www.youtube.com/embed/A_6w3-3nrtQ',
        }],
    },
    page: {
        title: "Page",
        addText: "a Page Block",
        icon: <FontAwesome fixedWidth prefix={'far'} name={'fa-file-alt'}/>,
        helpDocUrl: 'https://docs.google.com/viewer?pid=explorer&embedded=true&srcid=1fu9aLlsPr36kPS9WWKDmOU5R3tAIw2NnmrhCJ2lpBNg',
        videos: [{
            title: "Play Video",
            url: 'https://www.youtube.com/embed/5ZhTAIj8jlE',
        }],
    },
    section: {
        title: 'Section',
        addText: "a Section",
        icon: <FontAwesome fixedWidth name={'fa-columns'} prefix={'fas'}/>,
        helpDocUrl: 'https://docs.google.com/viewer?pid=explorer&embedded=true&srcid=1zT1YQK-aNy4DhoqIVM1nZ1byLZlBvPLc_7qXPpY-lYQ',
        videos: [],
    },
    weather: {
        title: "Weather",
        addText: "a Weather Block",
        icon: <FontAwesome fixedWidth name={'fa-bolt'} prefix={'fas'}/>,
        videos: [],
        helpDocUrl: 'https://docs.google.com/viewer?pid=explorer&embedded=true&srcid=1i9ErGrhgWu5OnSAjHZ7kJu1kJNnnV1QXsMNPDzgEdO4',
    },
    poll: {
        title: "Poll/Survey",
        addText: "a Poll Block",
        icon: <FontAwesome fixedWidth name={'fa-poll'} prefix={'fas'} />,
        videos: [],
        helpDocUrl: 'https://docs.google.com/viewer?pid=explorer&embedded=true&srcid=1i9ErGrhgWu5OnSAjHZ7kJu1kJNnnV1QXsMNPDzgEdO4',
    },
    reuse: {
        title: "Reuse",
        addText: "a Reuse Block",
        videos: [],
    },
    group: {
        title: "Group",
        icon: <FontAwesome fixedWidth name={'fa-columns'} prefix={'fas'}/>,
        addText: "a Group",
        videos: [],
    },
    department: {
        title: "Department",
        icon: <FontAwesome fixedWidth name={'fa-columns'} prefix={'fas'}/>,
        addText: "a Department",
        videos: [],
    },
    district: {
        title: "District",
        icon: <FontAwesome fixedWidth name={'fa-university'} prefix={'fas'}/>,
        addText: "a District",
        videos: [],
    },
    school: {
        title: "School",
        icon: <FontAwesome fixedWidth name={'fa-university'} prefix={'fas'}/>,
        addText: "a School",
        videos: [],
    },
    organization: {
        title: "Organization",
        icon: <FontAwesome fixedWidth name={'fa-columns'} prefix={'fas'}/>,
        addText: "an Organization",
        videos: [],
    },
    classroom: {
        title: "Organization",
        icon: <FontAwesome fixedWidth name={'fa-columns'} prefix={'fas'}/>,
        addText: "an Organization",
        videos: [],
    },
    person: {
        title: "Organization",
        icon: <FontAwesome fixedWidth name={'fa-columns'} prefix={'fas'}/>,
        addText: "an Organization",
        videos: [],
    },
}
